import React, { useState } from "react";

const OnboardingModal = () => {
  const [showModal, setShowModal] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);

  const onboardingSteps = [
    {
      stepVideo: "",
      actorVideo:
        "https://makeugc-assets-bucket.s3.us-east-2.amazonaws.com/onboarding%2Fr1.mov",
      description:
        "MakeUGC is your AI-powered solution for generating engaging UGC videos at scale. Get ready to transform your content marketing strategy with thousands of captivating UGC videos created in minutes!",
    },
    {
      stepVideo:
        "https://makeugc-assets-bucket.s3.us-east-2.amazonaws.com/onboarding%2FStep%201.mov",
      actorVideo:
        "https://makeugc-assets-bucket.s3.us-east-2.amazonaws.com/onboarding%2Fr2.mov",
      description:
        "You can type your script or generate your script with AI. You can also transcribe the script from an audio or video file.",
    },
    {
      stepVideo:
        "https://makeugc-assets-bucket.s3.us-east-2.amazonaws.com/onboarding%2FStep%202.mov",
      actorVideo:
        "https://makeugc-assets-bucket.s3.us-east-2.amazonaws.com/onboarding%2Fr3.mov",
      description:
        "Choose from the list of AI actors. You can also upload your own actors with custom video upload option.",
    },
    {
      stepVideo:
        "https://makeugc-assets-bucket.s3.us-east-2.amazonaws.com/onboarding%2FStep%203.mov",
      actorVideo:
        "https://makeugc-assets-bucket.s3.us-east-2.amazonaws.com/onboarding%2Fr4.mov",
      description:
        "Click on create button and your video will be ready in 6-7 minutes.",
    },
    {
      stepVideo: "",
      actorVideo:
        "https://makeugc-assets-bucket.s3.us-east-2.amazonaws.com/onboarding%2Fr5.mov",
      description:
        "Congratulations! 🎉 You're now ready to experience the revolution in UGC content creation.",
    },
  ];

  const handleNextStep = async () => {
    if (currentStep < 5) {
      setCurrentStep(currentStep + 1);
    }
    if (currentStep === 5) {
      // In the original code there was an API call here to update onboarding completion status
      // await updateOnboardingStatus({ onboardingCompleted: true });
      setShowModal(false);
    }
  };

  const handleSkip = async () => {
    // In the original code there was an API call here to update onboarding completion status
    // await updateOnboardingStatus({ onboardingCompleted: true });
    setShowModal(false);
  };

  return (
    <>
      {showModal && (
        <div
          id="default-modal"
          tabIndex={-1}
          aria-hidden="true"
          className="fixed inset-0 z-[9999] flex items-center justify-center overflow-y-auto overflow-x-hidden"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50"></div>
          <div className="relative mx-auto w-full max-w-4xl p-4">
            <div className="relative flex flex-col-reverse justify-between overflow-hidden rounded-lg bg-white shadow-xl sm:flex-row dark:bg-gray-700">
              <div className="flex w-full flex-col justify-between p-6 sm:w-3/5">
                <img
                  width={150}
                  height={100}
                  src="/logo/dark.png"
                  alt="Logo"
                  className="mb-6 hidden h-auto w-32 sm:block"
                />
                <div className="flex-grow">
                  {currentStep > 1 && currentStep < 5 ? (
                    <video
                      autoPlay={true}
                      loop={true}
                      muted={true}
                      playsInline={true}
                      src={onboardingSteps[currentStep - 1].stepVideo}
                      className="w-full rounded-lg"
                    />
                  ) : (
                    <p className="text-center text-base">
                      {onboardingSteps[currentStep - 1].description}
                    </p>
                  )}
                </div>
                <div className="mt-6 flex flex-col-reverse items-center justify-between gap-4 sm:flex-row">
                  <button
                    onClick={handleSkip}
                    className="border-body-color hover:bg-body-color text-bg-body-color inline-flex cursor-pointer items-center justify-center rounded border px-8 py-2 text-sm transition hover:bg-opacity-90 hover:text-white sm:text-base"
                  >
                    Skip
                  </button>
                  {currentStep > 1 && (
                    <button
                      type="button"
                      onClick={() => {
                        if (currentStep > 1) setCurrentStep(currentStep - 1);
                      }}
                      className="border-body-color hover:bg-body-color text-bg-body-color inline-flex cursor-pointer items-center justify-center rounded border px-8 py-2 text-sm transition hover:bg-opacity-90 hover:text-white sm:text-base"
                    >
                      Back
                    </button>
                  )}
                  <button
                    onClick={handleNextStep}
                    type="button"
                    className="border-primary bg-primary inline-flex cursor-pointer items-center justify-center rounded border px-8 py-2 text-sm text-white transition hover:bg-opacity-90 sm:text-base"
                  >
                    {currentStep === 1
                      ? "Discover"
                      : currentStep < 5
                      ? "Next"
                      : "Finish"}
                  </button>
                </div>
              </div>
              <div className="w-full p-6 sm:w-2/5">
                <img
                  width={150}
                  height={100}
                  src="/logo/dark.png"
                  alt="Logo"
                  className="mx-auto mb-4 block h-auto w-32 sm:hidden"
                />
                <video
                  autoPlay={true}
                  controls={true}
                  src={`${onboardingSteps[currentStep - 1].actorVideo}#t=0.001`}
                  className="aspect-[9/16] w-full rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OnboardingModal;
